import React, { Fragment } from "react";
// import { Container, Row, Col } from "reactstrap";
// import HealthcalculatorBtn from "../HealthcalculatorBtn";
// import BootstrapTable from 'react-bootstrap-table-next';
// import Loader from "../../Loader";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts'



class CommonLineChart extends React.Component{

    componentDidMount(){};

    render(){
        return(
            <Fragment>
                <ResponsiveContainer width="100%" height={350}>
                    <LineChart data={this.props.chartData} margin={{ top: 5, right: 30, left: 0, bottom: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" label={this.props.xAxisLabel} />
                        <YAxis label={this.props.yAxisLabel}/>
                        <Tooltip />
                        <Legend verticalAlign="top" height={36}/>
                        <Line type="monotone" dataKey="min" stroke="#82ca9d" legendType="circle" />
                        <Line type="monotone" dataKey="max" stroke="#8884d8" legendType="circle" />
                        <Line type="monotone" dataKey="you" stroke="#00aeef" legendType="circle" />
                    </LineChart>
                </ResponsiveContainer>
            </Fragment>
        )
    }

}

 export default CommonLineChart;


// WEBPACK FOOTER //
// ./src/views/HealthTools/CommonLineChart.js